require('../modules/es7.reflect.define-metadata');
require('../modules/es7.reflect.delete-metadata');
require('../modules/es7.reflect.get-metadata');
require('../modules/es7.reflect.get-metadata-keys');
require('../modules/es7.reflect.get-own-metadata');
require('../modules/es7.reflect.get-own-metadata-keys');
require('../modules/es7.reflect.has-metadata');
require('../modules/es7.reflect.has-own-metadata');
require('../modules/es7.reflect.metadata');
module.exports = require('../modules/_core').Reflect;



//////////////////
// WEBPACK FOOTER
// C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/~/core-js/es7/reflect.js
// module id = ../../../../core-js/es7/reflect.js
// module chunks = 0